/**
 * Created by yezh on 2018/2/24.
 * 全局过滤器
 */

import Vue from 'vue'
import {formatDate} from '../../assets/js/common.js'

Vue.filter('keepTwoNum', function (v) {
  v = Number(v)
  return v.toFixed(2)
})
// 时间格式化
Vue.filter('formatDate', function (time, fomat) {
  let date = new Date(time)
  if (fomat) {
    return formatDate(date, fomat)
  } else {
    return formatDate(date, 'yyyy-MM-dd')
  }
})
// 格式化为时间
Vue.filter('formatTime', function (time) {
  let date = new Date(time)
  return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
})
// 是否过滤器
Vue.filter('yesOrNo', function (v) {
  if (v === 'Y') {
    return '是'
  } else {
    return '否'
  }
})
// 价格保留两位小数
Vue.filter('shareNowPrice', function (v) {
  v = Number(v)
  return v.toFixed(2)
})
// 数字超过用 + 表示
Vue.filter('maxNumFix', function (v, m) {
  v = Number(v)
  if (v > m) {
    return m + '+'
  }
  return v
})
Vue.filter('articleWayFilter', function (v) {
  if (v === 'Z') {
    return '转载'
  } else {
    return '原创'
  }
})



// WEBPACK FOOTER //
// ./src/common/js/filter.js